import { get } from 'lodash'
import fetch from "node-fetch"
import {
  ApolloClient,
  InMemoryCache,
  HttpLink,
} from 'apollo-boost'

// shopify config
const config = {

  storeFront: {
    headers: {
        // "Content-Type": "application/json",
        // @TODO get access token from .env
        "X-Shopify-Storefront-Access-Token": 'd56bcac8c85ceaac71f412ab9031fc26'
    },
    uri: 'https://westward-whiskey.myshopify.com/api/2023-07/graphql.json'
  },
  admin: {
    headers: {
        "Content-Type": "application/json",
        // @TODO get access token from .env
        "X-Shopify-Access-Token": "49d1a010fc2ef7d46c1c348e86cb8a13"
    },
    uri: 'https://get-noosh.myshopify.com/admin/api/graphql.json'
  }
}

const createClient = function(options) {

    let clientConfig = config[ get(options, 'admin') ? 'admin' : 'storeFront']

    const cache = new InMemoryCache()
    const link = new HttpLink({
      ...clientConfig,
      fetch: fetch
    })

    // Store Front Client
    return new ApolloClient({ link, cache })
}

export default createClient
